var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50.78 93.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 686.38,
    y1: 134.93,
    x2: 716.82,
    y2: 104.82,
    gradientTransform: "translate(724.89 128.07) rotate(-163.77) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b272a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a282b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#064d4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#026868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#007978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007f7e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 687.87,
    y1: 75.72,
    x2: 724.1,
    y2: 109.59,
    gradientTransform: "translate(724.89 128.07) rotate(-163.77) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#007f7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#007978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#026868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#064d4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0a282b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b272a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 483.07,
    y1: 945.66,
    x2: 513.5,
    y2: 915.56,
    gradientTransform: "translate(-705.47 800.89) rotate(16.23) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 484.56,
    y1: 886.45,
    x2: 520.79,
    y2: 920.32,
    gradientTransform: "translate(-705.47 800.89) rotate(16.23) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.25,12.89c-5.35,2.94-1.9,17.17,1.74,23.8l10.06,18.33c1.56,2.85,.52,6.42-2.32,7.98l-5.15,2.83-2.83-5.16L2.67,42.35C-3.08,31.87,.76,18.65,11.25,12.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M11.25,12.89L29.58,2.83l5.15-2.83,2.83,5.15c1.56,2.85,.52,6.42-2.32,7.99l-18.33,10.06c-4.8,2.64-6.56,8.69-3.93,13.49-3.63-6.62-7.08-20.86-1.74-23.8Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.53,80.79c5.35-2.94,1.9-17.17-1.74-23.8l-10.06-18.33c-1.56-2.85-.52-6.42,2.32-7.98l5.15-2.83,2.83,5.16,10.06,18.33c5.76,10.48,1.91,23.7-8.58,29.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.53,80.79l-18.33,10.06-5.15,2.83-2.83-5.15c-1.56-2.85-.52-6.42,2.32-7.99l18.33-10.06c4.8-2.64,6.56-8.69,3.93-13.49,3.63,6.62,7.08,20.86,1.74,23.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBlue);
export default __webpack_public_path__ + "static/media/Header-blue.e6797723e463e90afc61c2f6972cf6b6.svg";
export { ForwardRef as ReactComponent };